import '@pwc/appkit-react/style/appkit-react.default.css';
import '@pwc/appkit-react/style/font-icon/css/appkit-font-embedded.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';

import 'react-simple-dropdown/styles/Dropdown.css';

import './style/styles.scss';

import React, { PureComponent } from 'react';
import ReduxToastr from 'react-redux-toastr';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import config from './config';
import { showScenariosMenuSelector, bsmFlagSelector } from './shared/store/selectors';

import Routes from './routes';
import Menu from './menu/menu.component';
import ErrorBoundary from './shared/errorBoundaries/ErrorBoundary.component';
import InitialDataProvider from './shared/initialDataProvider.component';
import GlobalModalContainer from './shared/globalModalContainer.component';
import JimProvider from './shared/jim/jimProvider.component';

import Dashboard from './dashboard/dashboard.component';
import ConnectionRunStatusDashboardPage from './dashboard/connectionRunStatusPage/connectionRunStatusDashboardPage.component';
import ProvisionQualityOverview from './dashboard/provisionQualityOverviewPage/provisionQualityOverviewPage.component';
import ProvisionQualitySingle from './dashboard/provisionQualitySinglePage/provisionQualitySinglePage.component';

import ScenariosPage from './scenarios/scenariosList/scenariosPage.component';
import ScenarioMemberListPage from './scenarios/scenarioMemberList/scenarioMemberListPage.component';
import ScenarioRulesPageComponent from './scenarios/scenarioRules/ScenarioRulesPage.component';

import ProvisionPage from './provisionPage/provisionPage.component';
import BatchProvisionsPage from './provisionPage/batchProvisionsPage/batchProvisionsPage.component';
import BatchAdjustmentsPage from './provisionPage/batchAdjustmentsPage/batchAdjustmentsPage.component';

import ViewTaxEntriesPage from './balanceSheetManagement/viewTaxEntriesPage/viewTaxEntriesPage.component';
import ViewTaxLifecyclePage from './balanceSheetManagement/viewTaxLifecyclePage/viewTaxLifecyclePage.component';
import ViewDeferredRollforwardPage from './balanceSheetManagement/viewDeferredRollforwardPage/viewDeferredRollforwardPage.component';
import ViewTaxReservesPage from './balanceSheetManagement/viewTaxReservesPage/viewTaxReservesPage.component';
import AddTaxEntryPage from './balanceSheetManagement/addTaxEntryPage/addTaxEntryPage.component';
import BatchTaxEntriesPage from './balanceSheetManagement/batchTaxEntriesPage/batchTaxEntriesPage.component';
import ApproveTaxEntriesPage from './balanceSheetManagement/approveTaxEntriesPage/approveTaxEntriesPage.component';
import ViewDiagnosticsPage from './balanceSheetManagement/viewDiagnosticsPage/viewDiagnosticsPage.component';
import NotificationsPage from './balanceSheetManagement/notificationsPage/notificationsPage.component';
import ViewAccountActivityPage from './balanceSheetManagement/viewAccountActivityPage/viewAccountActivityPage.component';
import ViewAccountBalancesPage from './balanceSheetManagement/viewAccountBalancesPage/viewAccountBalancesPage.component';
import RateChangeWorkpaperPage from './balanceSheetManagement/rateChangeWorkpaperPage/rateChangeWorkpaperPage.component';
import ConfigurationSettingsPage from './reports/configurationSettings/configurationSettingsPage.component';
import CustomReportsPage from './reports/customReports/customReportsPage.component';
import ViewEffectiveTaxRatePage from './reports/viewEffectiveTaxRatePage/viewEffectiveTaxRatePage.component';
import ViewTaxExpensePage from './reports/viewTaxExpensePage/viewTaxExpensePage.component';

import LogoutPage from './shared/pages/logoutPage/logoutPage.component';
import MaintenancePage from './shared/pages/maintenancePage/maintenancePage.component';
import AccessDenied from './shared/pages/accessDeniedPage/accessDenied.component';
import SessionExpired from './shared/pages/sessionExpiredPage/sessionExpired.component';
import MaintenanceBanner from './shared/maintenanceBanner/maintenanceBanner.component';

import ReturnToProvisionPage from './returnToProvision/returnToProvisionPage.component';

import { AuthorizeUserTree, AuthorizedRoute, permissions, permissionTypes } from './shared/authorization';
import BeginningBalancesPage from './administration/beginningBalancesPage/beginningBalancesPage.component';
import BusinessUnitSettingsPage from './administration/businessUnitSettingsPage/businessUnitSettingsPage.component';
import ConnectionMonitorPage from './dashboard/connectionMonitorPage/connectionMonitorPage.component';
import TaxAccountingSettingsPage from './administration/taxAccountingSettingsPage/taxAccountingSettingsPage.component';
import UserSettingsPage from './userSettings/userSettingsPage.component';
import UserProfileModal from './userData/userProfile/userProfileModal.component';
import ChangeClient from './menu/changeClient.component';
import TLSAccountSettingsPage from './administration/tlsAccountSettingsPage/tlsAccountsSettingsPage.component';
import LegalEntitySettingsPage from './administration/legalEntitySettingsPage/legalEntitySettingsPage.component';
import ObligationsPage from './administration/obligationsPage/obligationsPage.component';
import TaxBookingEntitiesPage from './administration/taxBookingEntitiesPage/taxBookingEntitiesPage.component';
import GLAccountListPage from './administration/GLAccountListPage/GLAccountListPage.component';
import AccountMapPage from './administration/accountMapPage/AccountMapPage.component';
import TaxRatesPage from './administration/taxRatesPage/taxRatesPage.component';
import SlAccountsPage from './administration/slAccountsPage/slAccountsPage.component';
import CompanyCodesPage from './administration/companyCodesPage/companyCodesPage.component';
import GlJournalsPage from './administration/glJournalsPage/glJournalsPage.component';
import BookToTaxDifferencesPage from './administration/bookToTaxDifferencesPage/bookToTaxDifferencesPage.component';
import CategoriesAndTagsPage from './administration/categoriesAndTagsPage/categoriesAndTagsPage.component';
import CustomReportsManagementPage from './administration/customReportsManagementPage/customReportsManagementPage.component';
import CustomGroupsPage from './administration/customGroupsPage/customGroupsPage.component';
import ClientPage from './administration/clientPage/clientPage.component';
import CurrencyConversionRatesPage from './administration/currencyConversionRatesPage/currencyConversionRatesPage.component';
import AdminTaxEntrySettingsPage from './administration/adminTaxEntrySettingsPage/adminTaxEntrySettingsPage.component';
import ChartOfAccountsPage from './administration/chartOfAccountsPage/chartOfAccountsPage.component';
import CommunicationsManagementPage from './administration/communicationsManagementPage/communicationsManagementPage.component';
import DatabaseLogsPage from './administration/databaseLogsPage/databaseLogsPage.component';
import ApplicationSettingsPage from './administration/applicationSettings/applicationSettingsPage.component';
import E2eHealthcheckPage from './administration/e2eHealthcheckPage/e2eHealthcheckPage.component';
import AdminImportPage from './administration/adminImportPage/adminImportPage.component';
import TrialBalanceThresholdPage from './administration/trialBalanceThresholdPage/trialBalanceThresholdPage.component';
import DiagnosticsPage from './administration/diagnosticsPage/diagnosticsPage.component';
import RolesPage from './administration/rolesPage/rolesPage.component';
import ClientAdministrationPage from './administration/clientAdministrationPage/clientAdministrationPage.component';
import UserExpirationPage from './administration/userExpirationPage/userExpirationPage.component';
import { SessionWatcher } from './shared/sessionWatcher/sessionWatcher';
import { CurrentPeriodWatcher } from './shared/currentPeriodWatcher/currentPeriodWatcher';
import BatchReportsPage from './reports/batchReports/batchReportsPage.component';
import MultiPeriodAnalysisPage from './reports/multiPeriodAnalysis/multiPeriodAnalysisPage.component';
import JobsNotifications from './menu/jobsMenu/JobsNotifications.component';
import { RedirectAfterLoginIfSaved } from './shared/redirectAfterLogin';
import { Pendo } from './shared/pendo.component';
import ScenarioReportWithDetails from './scenarios/scenarioReportWithDetails/ScenarioReportWithDetailsPage';
import { IsClientLocked } from './shared/clientLocked/IsClientLocked.component';
import { CustomLinksHandler } from './shared/CustomLinksHandler.component';

const renderHistoricalTaxExpense = props => <ViewTaxExpensePage {...props} useHistorical />;

const renderExpandableDetailsListTaxExpense = props => <ViewTaxExpensePage {...props} useExpandableDetailsList/>;

const renderDeferredRollforwardPage = props => (
  <IsClientLocked
    render={isClientLocked => ( // eslint-disable-line react/jsx-no-bind
      <ViewDeferredRollforwardPage
        {...props}
        isClientLocked={isClientLocked}
      />)}
  />
);

class App extends PureComponent {
  static propTypes = {
    showScenariosMenu: PropTypes.bool,
    bsmFlag: PropTypes.bool,
  };

  render() {
    return (
      <BrowserRouter basename={config.BASE_PATH}>
        <CustomLinksHandler/>
        <SessionWatcher/>
        <CurrentPeriodWatcher/>
        <div>
          <Menu />
          <ErrorBoundary>
            <div className="app">
              <Switch>
                <Route
                  path={Routes.LOGOUT}
                  component={LogoutPage}
                />
                <Route
                  path={Routes.MAINTENANCE}
                  component={MaintenancePage}
                />
                <Route
                  path={Routes.ACCESS_DENIED}
                  component={AccessDenied}
                />
                <Route
                  path={Routes.SESSION_EXPIRED}
                  component={SessionExpired}
                />
                <Route
                  exact
                  path={Routes.CHANGE_CLIENT}
                  component={ChangeClient}
                />
                <Route>
                  <InitialDataProvider>
                    <RedirectAfterLoginIfSaved/>
                    <MaintenanceBanner/>
                    <JimProvider />
                    <Route
                      exact
                      path={Routes.ROOT}
                      component={Dashboard}
                    />
                    <Route
                      exact
                      path={Routes.dashboard.MAIN}
                      component={Dashboard}
                    />

                    {
                      this.props.showScenariosMenu && (
                        <>
                          <Route
                            exact
                            path={Routes.scenarios.MAIN}
                            component={ScenariosPage}
                          />
                          <Route
                            exact
                            path={Routes.scenarios.MEMBERS_LIST}
                            component={ScenarioMemberListPage}
                          />

                          <Route
                            path={Routes.scenarios.rules.MAIN}
                            component={ScenarioRulesPageComponent}
                          />
                          <Route
                            exact
                            path={Routes.scenarios.PROVISION_REPORT}
                            component={ScenarioReportWithDetails}
                          />
                        </>
                      )
                    }
                    <Route
                      exact
                      path={Routes.dashboard.CONNECTION_RUN_STATUS}
                      component={ConnectionRunStatusDashboardPage}
                    />
                    <Route
                      exact
                      path={Routes.dashboard.PROVISION_QUALITY_OVERVIEW}
                      component={ProvisionQualityOverview}
                    />
                    <Route
                      exact
                      path={Routes.dashboard.PROVISION_QUALITY_SINGLE}
                      component={ProvisionQualitySingle}
                    />
                    <Route
                      exact
                      path={Routes.dashboard.PROVISION_QUALITY_SINGLE_WITH_PARAMS}
                      component={ProvisionQualitySingle}
                    />
                    <Route
                      exact
                      path={Routes.dashboard.CONNECTION_MONITOR}
                      component={ConnectionMonitorPage}
                    />

                    <Route
                      exact
                      path={Routes.provision.MAIN}
                      component={ProvisionPage}
                    />
                    <AuthorizedRoute
                      requireCompanyCode={false}
                      path={Routes.provision.BATCH_ADJUSTMENTS}
                      component={BatchAdjustmentsPage}
                    />
                    <AuthorizedRoute
                      path={Routes.provision.BATCH_PROVISIONS}
                      component={BatchProvisionsPage}
                    />
                    {
                      this.props.bsmFlag && (
                        <AuthorizeUserTree
                          withPermissions={[{
                            permissionType: permissionTypes.VIEW,
                            permissionPath: permissions.BALANCE_SHEET_MANAGEMENT_VIEW,
                          }]}
                        >
                          <div>
                            <Route
                              path={Routes.balanceSheetManagement.VIEW_TAX_ENTRIES}
                              component={ViewTaxEntriesPage}
                            />
                            <AuthorizedRoute
                              path={Routes.balanceSheetManagement.ADD_TAX_ENTRY}
                              component={AddTaxEntryPage}
                            />
                            <AuthorizedRoute
                              path={Routes.balanceSheetManagement.BATCH_TAX_ENTRIES}
                              component={BatchTaxEntriesPage}
                            />
                            <Route
                              path={Routes.balanceSheetManagement.APPROVE_TAX_ENTRIES}
                              component={ApproveTaxEntriesPage}
                            />
                            <Route
                              path={Routes.reports.VIEW_TAX_LIFECYCLE}
                              component={ViewTaxLifecyclePage}
                            />
                            <Route
                              path={Routes.balanceSheetManagement.VIEW_ACCOUNT_ACTIVITY}
                              component={ViewAccountActivityPage}
                            />
                            <Route
                              path={Routes.balanceSheetManagement.VIEW_ACCOUNT_BALANCES}
                              component={ViewAccountBalancesPage}
                            />
                            <Route
                              path={Routes.reports.VIEW_DEFERRED_ROLLFORWARD}
                              render={renderDeferredRollforwardPage}
                            />
                            <Route
                              path={Routes.balanceSheetManagement.VIEW_DIAGNOSTICS}
                              component={ViewDiagnosticsPage}
                            />
                            <Route
                              path={Routes.balanceSheetManagement.VIEW_NOTIFICATIONS}
                              component={NotificationsPage}
                            />
                            <Route
                              path={Routes.reports.VIEW_TAX_RESERVES}
                              component={ViewTaxReservesPage}
                            />
                            <AuthorizedRoute
                              path={Routes.balanceSheetManagement.RATE_CHANGE_WORKPAPER}
                              component={RateChangeWorkpaperPage}
                            />
                          </div>
                        </AuthorizeUserTree>
                      )
                    }

                    <Route
                      path={Routes.administration.BEGINNING_BALANCES}
                      component={BeginningBalancesPage}
                    />

                    <Route
                      path={Routes.administration.BUSINESS_UNIT_SETTINGS}
                      component={BusinessUnitSettingsPage}
                    />

                    <Route
                      path={Routes.administration.TAX_ACCOUNTING_SETTINGS}
                      component={TaxAccountingSettingsPage}
                    />

                    <Route
                      path={Routes.administration.TAX_RATES}
                      component={TaxRatesPage}
                    />

                    <Route
                      path={Routes.reports.CONFIGURATION_SETTING}
                      component={ConfigurationSettingsPage}
                    />

                    <AuthorizedRoute
                      exact
                      path={Routes.reports.CUSTOM_REPORT}
                      component={CustomReportsPage}
                    />

                    <AuthorizedRoute
                      exact
                      path={Routes.reports.CUSTOM_REPORTS}
                      component={CustomReportsPage}
                    />

                    <Route
                      path={Routes.reports.EFFECTIVE_TAX_RATE}
                      component={ViewEffectiveTaxRatePage}
                    />

                    <Route
                      path={Routes.reports.TAX_EXPENSE}
                      component={ViewTaxExpensePage}
                    />

                    <Route
                      path={Routes.reports.HISTORICAL_TAX_EXPENSE}
                      render={renderHistoricalTaxExpense}
                    />

                    <Route
                      path={Routes.reports.TAX_EXPENSE_WITH_EXPANDABLE_DETAILS_LIST}
                      render={renderExpandableDetailsListTaxExpense}
                    />

                    <AuthorizedRoute
                      path={Routes.reports.BATCH_REPORTS}
                      component={BatchReportsPage}
                    />

                    <Route
                      path={Routes.reports.MULTI_PERIOD_ANALYSIS}
                      component={MultiPeriodAnalysisPage}
                    />

                    <Route
                      exact
                      path={Routes.returnToProvision.MAIN}
                      component={ReturnToProvisionPage}
                    />

                    <Route
                      path={Routes.administration.TLS_ACCOUNT_SETTINGS}
                      component={TLSAccountSettingsPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.DATABASE_LOGS}
                      component={DatabaseLogsPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.COMMUNICATIONS_MANAGEMENT}
                      component={CommunicationsManagementPage}
                    />

                    <Route
                      path={Routes.administration.LEGAL_ENTITY_SETTINGS}
                      component={LegalEntitySettingsPage}
                    />

                    <Route
                      path={Routes.administration.OBLIGATIONS}
                      component={ObligationsPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.CUSTOM_REPORTS_MANAGEMENT}
                      component={CustomReportsManagementPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.APPLICATION_SETTINGS}
                      component={ApplicationSettingsPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.E2E_HEALTHCHECK}
                      component={E2eHealthcheckPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.ADMIN_IMPORT}
                      component={AdminImportPage}
                    />

                    <Route
                      path={Routes.administration.CATEGORIES_AND_TAGS}
                      component={CategoriesAndTagsPage}
                    />

                    <Route
                      path={Routes.administration.TAX_BOOKING_ENTITIES}
                      component={TaxBookingEntitiesPage}
                    />

                    <Route
                      path={Routes.administration.BOOK_TO_TAX_DIFFERENCE}
                      component={BookToTaxDifferencesPage}
                    />

                    <Route
                      path={Routes.administration.COMPANY_CODES}
                      component={CompanyCodesPage}
                    />

                    <Route
                      path={Routes.administration.CURRENCY_CONVERSION_RATES}
                      component={CurrencyConversionRatesPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.CUSTOM_GROUPS}
                      component={CustomGroupsPage}
                    />

                    <Route
                      path={Routes.administration.CHART_OF_ACCOUNTS}
                      component={ChartOfAccountsPage}
                    />

                    <Route
                      path={Routes.administration.CLIENT_ADMINISTRATION}
                      component={ClientAdministrationPage}
                      withPermissions={[{
                        permissionType: permissionTypes.VIEW,
                        permissionPath: permissions.CLIENT_ADMININISTRATION,
                      }]}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.USER_SETTINGS}
                      component={UserSettingsPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.USER_EXPIRATION}
                      component={UserExpirationPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.ROLES}
                      component={RolesPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.ADMIN_TAX_ENTRY}
                      component={AdminTaxEntrySettingsPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.GL_ACCOUNT_LIST}
                      component={GLAccountListPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.ACCOUNT_MAP}
                      component={AccountMapPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.DIAGNOSTICS}
                      component={DiagnosticsPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.TRIAL_BALANCE_THRESHOLD}
                      component={TrialBalanceThresholdPage}
                    />
                    <AuthorizedRoute
                      path={Routes.administration.SL_ACCOUNTS_PAGE}
                      component={SlAccountsPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.GL_JOURNALS}
                      component={GlJournalsPage}
                    />

                    <AuthorizedRoute
                      path={Routes.administration.CLIENT}
                      component={ClientPage}
                    />

                    <UserProfileModal />
                  </InitialDataProvider>
                </Route>
              </Switch>
            </div>
          </ErrorBoundary>
          <Pendo />
          <ReduxToastr
            newestOnTop
            position="top-right"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
          />
          <GlobalModalContainer />
          <JobsNotifications/>
        </div>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = state => ({
  showScenariosMenu: showScenariosMenuSelector(state),
  bsmFlag: bsmFlagSelector(state),
});

export default connect(mapStateToProps)(App);
